import FederatedPhotoError from './FederatedPhotoError';

const MultiFamilyLogo = ({ id = '', url = '', errorDto = {} } = {}) => ({
  id: String(id),
  url: String(url),
  errorDto: FederatedPhotoError(errorDto),
});

export default MultiFamilyLogo;

export type MultiFamilyLogoProps = ReturnType<typeof MultiFamilyLogo>;
